module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"export":"Export"},"de":{"export":"Exportieren"}}')
  delete Component.options._Ctor
}
